import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --primary-color: #F68B21; /* Bright Orange */
    --secondary-color: #141340; /* Very Dark Blue */
    --background-color: #f8f9fa;
    --text-color: #333;
    --light-gray: #e9ecef;
    --medium-gray: #adb5bd;
    --dark-gray: #495057;
    --success-color: #28a745;
    --danger-color: #dc3545;
    --warning-color: #ffc107;
    --info-color: #17a2b8;
    --border-radius: 4px;
    --box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    --transition: all 0.3s ease;
    --font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  }

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  body {
    font-family: var(--font-family);
    background-color: var(--background-color);
    color: var(--text-color);
    line-height: 1.6;
  }

  a {
    text-decoration: none;
    color: var(--primary-color);
    transition: var(--transition);
    
    &:hover {
      color: var(--secondary-color);
    }
  }

  button {
    cursor: pointer;
    border: none;
    border-radius: var(--border-radius);
    transition: var(--transition);
    font-family: var(--font-family);
  }

  input, select, textarea {
    font-family: var(--font-family);
    border-radius: var(--border-radius);
    border: 1px solid var(--medium-gray);
    padding: 8px 12px;
    transition: var(--transition);
    
    &:focus {
      outline: none;
      border-color: var(--primary-color);
      box-shadow: 0 0 0 2px rgba(246, 139, 33, 0.2);
    }
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 1rem;
    
    th, td {
      padding: 0.75rem;
      text-align: left;
      border-bottom: 1px solid var(--light-gray);
    }
    
    th {
      background-color: var(--light-gray);
      color: var(--secondary-color);
      font-weight: 600;
    }
    
    tr:hover {
      background-color: rgba(246, 139, 33, 0.05);
    }
  }

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 15px;
  }

  .page-title {
    color: var(--secondary-color);
    margin-bottom: 1.5rem;
    font-weight: 600;
    border-bottom: 2px solid var(--primary-color);
    padding-bottom: 0.5rem;
    display: inline-block;
  }

  /* Responsive styles */
  @media (max-width: 1200px) {
    .container {
      padding: 0 15px;
    }
  }

  @media (max-width: 768px) {
    .container {
      padding: 0 10px;
    }
    
    table {
      font-size: 0.9rem;
      
      th, td {
        padding: 0.5rem 0.25rem;
      }
    }
    
    .page-title {
      font-size: 1.5rem;
    }
  }

  @media (max-width: 480px) {
    .container {
      padding: 0 8px;
    }
    
    table {
      font-size: 0.8rem;
      
      th, td {
        padding: 0.4rem 0.2rem;
      }
    }
    
    .page-title {
      font-size: 1.3rem;
    }
  }
`;

export default GlobalStyles; 